import FleetsSection from '@src/main/modules/parameters/ui/fleet-positions/components/fleets/FleetsSection';
import PositionsSection from '@src/main/modules/parameters/ui/fleet-positions/components/positions/PositionsSection';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import { FC } from 'react';
import styles from './FleetAndPositions.module.scss';

const FleetsAndPositions: FC = () => (
  <ContentCard>
    <div className={styles['grid-container']}>
      <FleetsSection />
      <PositionsSection />
    </div>
  </ContentCard>
);

export default FleetsAndPositions;
